import { Link } from "react-router-dom";

export default function FoodHero() {
  return (
    <section className="relative w-full min-h-[90vh] overflow-hidden flex items-center pt-40 md:pt-44 pb-24">
      <img
        src="/images/food/mixing-tanks.webp"
        alt="Food Processing Equipment"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/25"></div>

      <div className="relative z-10 flex flex-col justify-center px-6 md:px-16 max-w-7xl mx-auto w-full">
        <span className="inline-block text-teal-400 text-xs font-bold uppercase tracking-widest mb-4">
          Custom Fabrication Specialists
        </span>
        <h1 className="text-white text-3xl sm:text-4xl md:text-5xl xl:text-6xl font-extrabold leading-tight max-w-3xl uppercase tracking-tight">
          Food Processing<br />
          <span className="text-teal-400">Equipment</span> Built for You
        </h1>
        <p className="text-white/70 text-base md:text-lg mt-6 max-w-xl leading-relaxed">
          From mixing tanks and conveyors to cutting tables and storage silos —
          ISMAN engineers and fabricates food-grade stainless steel equipment
          that meets KEBS, HACCP, and ISO hygiene standards for Kenya's food industry.
        </p>

        {/* Stats */}
        <div className="flex flex-wrap gap-8 mt-10">
          {[
            { value: "350+", label: "Systems Installed" },
            { value: "15+", label: "Years Experience" },
            { value: "SS304", label: "Food-Grade Steel" },
            { value: "HACCP", label: "Compliant Builds" },
          ].map((stat) => (
            <div key={stat.label}>
              <p className="text-teal-400 text-3xl font-extrabold">{stat.value}</p>
              <p className="text-white/60 text-xs uppercase tracking-wider mt-1">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap gap-4 mt-10">
          <a
            href="#inquiry"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector("#inquiry")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="bg-teal-600 hover:bg-teal-500 text-white font-bold px-8 py-3 rounded-md uppercase text-sm tracking-wider transition-colors cursor-pointer whitespace-nowrap"
          >
            Request a Quote
          </a>
          <a
            href="#products"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector("#products")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="bg-white/10 hover:bg-white/20 border border-white/30 text-white font-bold px-8 py-3 rounded-md uppercase text-sm tracking-wider transition-colors cursor-pointer whitespace-nowrap"
          >
            View Products
          </a>
        </div>
      </div>

      {/* Back link */}
      <div className="absolute top-6 left-6 md:left-16">
        <Link
          to="/"
          className="flex items-center gap-2 text-white/70 hover:text-white text-xs uppercase tracking-wider transition-colors"
        >
          <i className="ri-arrow-left-line"></i> Back to Home
        </Link>
      </div>
    </section>
  );
}
